import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { getIsOperatingUnitTransport } from './orgutil';

import * as api from '~services/api';

import {
  SelectField,
  TextField,
  CheckboxField,
  TagField,
  RadioButtonField,
  TimeField,
} from '~fields';

import { getTimeInfo } from '~services/api.helpers';

import OpenHours from '../formik/components/OpenHours';
import QRMenuWrapper from '../formik/components/QRMenuWrapper';

import { Gap } from '~ui-kit';

const getIsPatientTransport = content => content === 'PATIENT';

const PatientsTransportsForm = props => {
  const [timeInfo, setTimeInfo] = useState();
  const { organizations, form, formId } = props;
  const { accuracy, time, fromOrganization, toOrganization, content } =
    props.formik.values;
  const { setFieldValue } = props.formik;

  const organizationOptions = organizations?.map(o => ({
    value: o.id,
    label: o.name,
  }));

  const isOperatingUnitTransport = getIsOperatingUnitTransport(
    fromOrganization,
    toOrganization,
    organizations
  );

  const isPatientTransport = getIsPatientTransport(content);

  const renderPrecautions = () => (
    <Checkboxes>
      <CheckboxField
        name="contactPrecautions"
        id="contactPrecautions"
        fallbackLabel="Kosketuseristys"
      />
      <CheckboxField
        name="dropletPrecautions"
        id="dropletPrecautions"
        fallbackLabel="Pisaraeristys"
      />
      <CheckboxField
        name="airbornePrecautions"
        id="airbornePrecautions"
        fallbackLabel="Ilmaeristys"
      />
    </Checkboxes>
  );

  const precautionsOptions = [
    { label: 'Ei eristystä', id: 'noPrecautions', value: 'NO' },
    {
      label: 'Kuljetuksessa on eristystarve',
      id: 'somePrecautions',
      value: 'YES',
      renderConditional: renderPrecautions,
    },
  ];

  useEffect(() => {
    const updateTimeInfo = async time => {
      const tempTimeInfo = await getTimeInfo(formId, {
        accuracy,
        time,
      });
      setTimeInfo(tempTimeInfo);
    };

    if (accuracy && time && formId) {
      updateTimeInfo(time.toISOString());
    }
  }, [accuracy, time, formId]);

  const navigate = useNavigate();

  const qrCodeOptions = [
    {
      label: 'Potilas',
      onRead: async data => {
        try {
          const patient = await api.get(`data/patientdata/patient/${data}`);
          setFieldValue('patientName', patient.name);
          navigate(-1);
        } catch (e) {
          console.error('Error in fetching patient name from API', e);
        }
      },
    },
    // {
    //   label: 'Lähtöpiste',
    //   onRead: data => {
    //     setFieldValue('fromOrganization', data);
    //     dispatch(goBack());
    //   },
    // },
    // {
    //   label: 'Päätepiste',
    //   onRead: data => {
    //     setFieldValue('toOrganization', data);
    //     dispatch(goBack());
    //   },
    // },
  ];

  return (
    <QRMenuWrapper options={qrCodeOptions}>
      <FormWrapper>
        <TextField
          required
          name="patientName"
          id="patientName"
          fallbackLabel="Potilaan koko nimi"
        />
        <Gap height="16px" />
        <Location>
          <StyledSelectField
            required
            searchable
            name="fromOrganization"
            options={organizationOptions}
            fallbackLabel="Lähtöpiste"
            fallbackPlaceholder="Valitse"
            id="fromOrganization"
          />
          <Gap height="8px" />
          <TextField
            name="fromRoom"
            fallbackPlaceholder="Tarkka sijainti"
            flat
          />
        </Location>
        <Gap height="16px" />
        <Location>
          <StyledSelectField
            required
            searchable
            name="toOrganization"
            options={organizationOptions}
            fallbackLabel="Päätepiste"
            fallbackPlaceholder="Valitse"
            id="toOrganization"
          />
          <Gap height="8px" />
          <TextField name="toRoom" fallbackPlaceholder="Tarkka sijainti" flat />
        </Location>
        <Gap height="16px" />
        <TagField required name="accuracy" />
        <Gap height="16px" />
        <DateContainer>
          <TimeField
            name="time"
            fallbackLabel="Perilläoloaika"
            timeIntervals={10}
            noPastDate
            noPastTime
            row
            required
          />
        </DateContainer>
        {form && timeInfo && <OpenHours {...{ formInfo: form, timeInfo }} />}
        <Gap height="16px" />

        {(isOperatingUnitTransport || !isPatientTransport) && (
          <TagField required name="content" />
        )}

        {isPatientTransport && (
          <EquipmentField
            fallbackPlaceholder="Valitse..."
            name="equipment"
            id="equipment"
            required
          />
        )}

        {isPatientTransport && <CheckboxField name="oxygen" id="oxygen" />}

        <Gap height="16px" />
        <TextField name="remarks" id="remarks" />
        <Gap height="16px" />
        <RadioButtonField
          required
          fallbackLabel="Eristys"
          name="precautions"
          id="precautions"
          options={precautionsOptions}
        />
      </FormWrapper>
    </QRMenuWrapper>
  );
};

const FormWrapper = styled.div`
  & > * {
    margin-bottom: 24px;
  }
`;

const Location = styled.div`
  max-width: var(--field-width);
`;

const StyledSelectField = styled(SelectField)``;

const EquipmentField = styled(SelectField)`
  min-width: 200px;
`;

const DateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  max-width: var(--field-width);
`;

const Checkboxes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export default PatientsTransportsForm;
